module.exports = __webpack_public_path__ + "static/img/partner7.56cec29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/partner7.png
// module id = w5Ly
// module chunks = 0